import {PropsWithChildren, ReactElement, isValidElement} from 'react';

type Props = {
  sequences: number[];
} & PropsWithChildren<React.ReactNode>;

function OrganizerBySequence({sequences, children}: Props) {
  const childrenArray = Array.isArray(children) ? children : [children];

  // Filter out null/undefined children and convert to array of ReactElements
  const validChildren = childrenArray.filter((child): child is ReactElement =>
    isValidElement(child)
  );

  // Create a map of key to child for quick lookup
  const childrenMap = new Map<number | string, ReactElement>();
  validChildren.forEach((child) => {
    if (child.key != null) {
      // Convert key to number if it's a string representation of a number
      const key =
        typeof child.key === 'string' && !isNaN(Number(child.key))
          ? Number(child.key)
          : child.key;
      childrenMap.set(key, child);
    }
  });

  // Build sorted array based on sequence
  const sortedChildren: ReactElement[] = [];

  // First, add children in the order specified by sequences
  sequences.forEach((seqKey) => {
    const child = childrenMap.get(seqKey);
    if (child) {
      sortedChildren.push(child);
      childrenMap.delete(seqKey); // Remove from map to avoid duplicates
    }
  });

  // Then, add any remaining children that weren't in the sequence (in their original order)
  validChildren.forEach((child) => {
    if (child.key != null) {
      const key =
        typeof child.key === 'string' && !isNaN(Number(child.key))
          ? Number(child.key)
          : child.key;
      if (childrenMap.has(key)) {
        sortedChildren.push(child);
      }
    }
  });

  return <>{sortedChildren}</>;
}

export default OrganizerBySequence;
